import React from 'react'
import PropTypes from 'prop-types'
import {
  Button, Card, Container, Display3, Display4
} from '@sainsburys-tech/fable'
import api from '../../utils/api'
import LoadingOverlay from '../LoadingOverlay'
import logger from '../../utils/logger'
import TitleComponent from '../PageTitle'

class AssessmentStatements extends React.Component {
  constructor() {
    super()

    this.state = {
      statements: [],
      loading: true
    }
  }

  componentDidMount() {
    const { setHeader, setSignOutHeader, siteType } = this.props

    setHeader()
    setSignOutHeader(true)

    api.getAssessmentStatements(siteType)
      .then((res) => {
        const sortedArray = res.sort((a, b) => a.order - b.order)
        this.setState({ statements: sortedArray, loading: false })
      })
      .catch(err => logger.logError(err))
  }

  rejectClick = () => {
    const { history } = this.props

    this.setState({ loading: true })

    history.goBack()
  }

  acceptClick = () => {
    const { history, visit, selectedWorkOrder } = this.props

    this.setState({ loading: true })

    api.addWorkOrder(visit.id, selectedWorkOrder).then((result) => {
      if (result) {
        history.push('/passes')
      }
    })
  }

  render() {
    const { selectedWorkOrder } = this.props

    const { statements, loading } = this.state

    return (
      <Container className="dsib-assessmentStatements">
        <TitleComponent workOrderNumber={selectedWorkOrder} text="Please confirm the following statements" />
        <Card className="dsib-assessmentStatements__card">
          <div className="dsib-assessmentStatements__cardInner">
            <ul className="dsib-assessmentStatements__list">
              {statements.map(ss => (
                <li key={ss.order} className="dsib-assessmentStatements__listItem">
                  {ss.statement}
                </li>
              ))}
            </ul>
          </div>
          <div className="dsib-assessmentStatements__buttons">
            <Button variant="primary" isFullWidth onClick={this.acceptClick}>
              I confirm
            </Button>
            <Button variant="secondary" isFullWidth onClick={this.rejectClick}>
              I don&apos;t confirm
            </Button>
          </div>
        </Card>


        {loading && <LoadingOverlay hasBackground />}
      </Container>
    )
  }
}

AssessmentStatements.propTypes = {
  selectedWorkOrder: PropTypes.string.isRequired,
  setHeader: PropTypes.func.isRequired,
  setSignOutHeader: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
    goBack: PropTypes.func.isRequired
  }).isRequired,
  visit: PropTypes.shape({
    id: PropTypes.number.isRequired
  }).isRequired,
  siteType: PropTypes.string
}

AssessmentStatements.defaultProps = {
  siteType: null
}

export default AssessmentStatements
